// extracted by mini-css-extract-plugin
export default {"separator":"_F_iat","menuWrapper":"sjPohq","menu":"jz2Tij","twoButtonsInSigningSection":"VKQJs6","withSeparatorAfter":"r0egAf","menuItemSeparator":"XQYyi8","mobileOnly":"lRtZ3Z"};